// prop-type is a library for typechecking of props
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

// NewUser page components
import FormField from "components/FormField";

function LoginForm({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { email, password } = formField;
  const { email: emailV, password: passwordV } = values;
  return (
    <MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <FormField
            type={email.type}
            label={email.label}
            name={email.name}
            defaultValue={emailV}
            placeholder={email.placeholder}
            error={errors.email && touched.email}
            success={emailV.length > 0 && !errors.email}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            type={password.type}
            label={password.label}
            name={password.name}
            defaultValue={passwordV}
            placeholder={password.placeholder}
            error={errors.password && touched.password}
            success={passwordV.length > 0 && !errors.password}
            inputProps={{ autoComplete: "" }}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

// typechecking props for LoginForm
LoginForm.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default LoginForm;
